import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { global_variables } from '../../../environments/global_variables';
import { HttpService } from '../../services/http.service';
import { UserAccessebiltyService } from 'src/app/live-page/services/user-accessebilty.service';
@Component({
   selector: 'app-user-modal',
   templateUrl: './user-modal.component.html',
   styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent implements OnInit {
   context: any;
   strUserType: string;
   bIsProcess: boolean;
  isFeatureAllowed: boolean;
   arrObjRoles: Object[];
   arrObjFeatures: Object[];
   arrStrUserTypes: string[];
   arrStrUserStatus: string[];
isCustomers: string;
   settingForm: FormGroup;
   formErrors: Object;
   validationMessages: Object;

   constructor(
      public dialgoRef: MatDialogRef<UserModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _httpService: HttpService,
      public _snackBar: MatSnackBar, 
      public _userAuth: UserAccessebiltyService
   ) {
      this.context = data;
      this.strUserType = this.context['type'];
      this.arrStrUserTypes = global_variables['userTypes'];
      this.arrStrUserStatus = global_variables['userStatus'];

      if (this.strUserType === this.arrStrUserTypes[0]) {
         // staff
         this.arrObjRoles = [
            { value: 'admin', display: 'Administrator' },
            { value: 'developer', display: 'Developer' },
            { value: 'debugger', display: 'Debug Operator' },
            { value: 'operator', display: 'Operator' },
            { value: 'viewer', display: 'Viewer' },
         ];
         // userFeatures: ['chromatogram', 'detectedPeaks', 'tempRH', 'flowRate', 'capacitance'],
      
      } else {
         // customer
         this.arrObjRoles = [
            { value: 'admin', display: 'Administrator' },
            { value: 'operator', display: 'Operator' },
            { value: 'viewer', display: 'Viewer' },
         ];
         this.arrObjFeatures = [
            { value: 'chromatogram', display: 'Chromatogram' }
         ]
      }
this.isCustomers = 'customers'
      this.bIsProcess = false;
   }


   ngOnInit() {
      console.log(this._userAuth.getUserType(), "hry")
      this.isCustomers = this._userAuth.getUserType();
      this.isFeatureAllowed = this.isCustomers === 'staffs' && this.strUserType === 'customers'  ? true : false;
      const userFeatures = this.context['user']['features'];
      this.settingForm = new FormGroup({
         role: new FormControl(
           this.context['user']['role'] ? this.context['user']['role'] : this.arrObjRoles[0]['value'],
           [<any>Validators.required]
         ),
         status: new FormControl(this.context['user']['status'], [<any>Validators.required]),
         features: new FormControl(
            Array.isArray(userFeatures)
              ? userFeatures.filter(f => f !== undefined && f !== null)
              : (userFeatures ? [userFeatures] : [])
         )
       });
       
   }

   /**
    * submit form
    */
   onSubmit() {
      const formValue = this.settingForm.value;
    
      const objUpdateValue: any = {
        role: formValue.role,
        status: formValue.status,
      };
    
      // Only add 'features' if it's a non-empty, valid array
      if (formValue.features && Array.isArray(formValue.features)) {
        const cleanedFeatures = formValue.features.filter(f => f !== undefined && f !== null);
        objUpdateValue.features = cleanedFeatures.length > 0 ? cleanedFeatures : []; // Save empty array if user deselected all
      } else {
        objUpdateValue.features = []; // Explicitly save empty if features is undefined/null
      }
    
      const selectedUser = this.context['user'];
      this.bIsProcess = true;
    
      this._httpService
        .updateAsObject(
          `${environment['APIS']['USERS']}/${this.strUserType}/${selectedUser['key']}/action`,
          objUpdateValue
        )
        .then(
          () => {
            this._snackBar.open('User information update is successful!', 'Success', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
            });
            this.bIsProcess = false;
            this.dialgoRef.close();
          },
          error => {
            this._snackBar.open('Failed to update in Firebase', 'Error', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
            });
            console.error(error);
            this.bIsProcess = false;
            this.dialgoRef.close();
          }
        );
    }
    
    

   close(event: any) {
      event.preventDefault();
      this.dialgoRef.close();
   }
}
